// extracted by mini-css-extract-plugin
module.exports = {"scoreLine":"e_bA","scoreRing":"e_cA","badge":"e_dA","badgeImage":"e_eA","spaced":"e_fA"};